export default __webpack_public_path__ + "static/moonalgo-logo-30e834b1a7be5901b7421a669589babc.png";